module.exports = __webpack_public_path__ + "media/views/reviews/images/star-grey-2a1fd9fd3df554a8cf36368da72093f8.svg";